import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'
import { getInstoreConfig } from '../../../../utils/configUtils'

import * as EmailUtils from '@/checkout-instore-legacy/utils/EmailUtils'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'

import Button from '@vtex/styleguide/lib/Button'

class CustomerAnonymous extends Component {
  constructor(props) {
    super(props)
    this.state = {
      allowAnonymousUser: getInstoreConfig().allowAnonymousUser,
    }
  }

  handleAnonymous = () => {
    const email = EmailUtils.getNewAnonymousEmail()
    logClickEvent('identify-anonymously', 'Sale')
    this.props.onSetCustomerIdentification(email)
  }

  componentDidMount() {
    CustomEvent.listenEvent('config.updated', this.handleConfigUpdated)
  }

  componentWillUnmount() {
    CustomEvent.unlistenEvent('config.updated', this.handleConfigUpdated)
  }

  handleConfigUpdated = () => {
    this.setState({
      allowAnonymousUser: getInstoreConfig().allowAnonymousUser,
    })
  }

  render() {
    if (!this.state.allowAnonymousUser) return null

    return (
      <div id="customer-anonymous-container" className="tc pb6">
        <div className="mt5 mb4 f4-ns tc">
          <FormattedMessage id="orLabel" />
        </div>
        <Button
          id="useranonymous-button"
          onClick={this.handleAnonymous}
          variation="tertiary"
        >
          <FormattedMessage id="anonymousContinue" />
        </Button>
      </div>
    )
  }
}

CustomerAnonymous.propTypes = {
  onSetCustomerIdentification: PropTypes.func,
}

export default CustomerAnonymous
